<script setup lang="ts">
import { defineProps } from 'vue'
import { Notification, useNotificationState } from '../../utilities/useNotifications'

import { CheckCircleIcon, ExclamationCircleIcon, ExclamationIcon } from '@heroicons/vue/solid'

const notificationStore = useNotificationState()

defineProps<{
    notification: Notification
}>()
</script>

<template>
    <div
        class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
        <div class="p-4">
            <div class="flex items-start">
                <div class="flex-shrink-0">
                    <CheckCircleIcon v-if="notification.type === 'Success'" class="h-6 w-6 text-green-400" />
                    <ExclamationCircleIcon v-else-if="notification.type === 'Error'" class="h-6 w-6 text-red-400" />
                    <ExclamationIcon v-else-if="notification.type === 'Warning'" class="h-6 w-6 text-yellow-400" />
                </div>
                <div class="ml-3 w-0 flex-1 pt-0.5">
                    <p v-if="notification.title" class="mb-1 text-sm font-semibold text-gray-900">
                        {{ notification.title }}
                    </p>
                    <p class="text-sm text-gray-500">
                        {{ notification.message }}
                    </p>
                </div>
                <div class="ml-4 flex flex-shrink-0">
                    <button
                        class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                        @click="notificationStore.removeNotification(notification.id)">
                        <span class="sr-only">Close</span>
                        <!-- Heroicon name: solid/x -->
                        <svg
                            class="h-5 w-5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true">
                            <path
                                fill-rule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
